import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

const AppSkeleton = () => (
  <Grid item xs={12} md={6} lg={4}>
    <Card>
      <Box display="flex">
        <Box pl={1} py={2}>
          <Skeleton variant="rect" height={75} width={75} />
        </Box>
        <CardContent style={{ paddingBottom: 0, flex: 1 }}>
          <Skeleton variant="text" />
          <Skeleton variant="text" width="50%" />
          <Box mt={1}>
            <Skeleton variant="text" />
          </Box>
          <Box mt={2} display="flex">
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Skeleton variant="rect" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="rect" />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="rect" />
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Box>
      <CardActions>
        <Skeleton
          variant="rect"
          width={100}
          style={{ marginLeft: 'auto', marginRight: 8, marginTop: 16 }}
        />
      </CardActions>
    </Card>
  </Grid>
);

export default AppSkeleton;
